export type TIDRouteParams = {
    id: string;
};

export const MANAGEMENT_ROUTE = 'management';
export const DASHBOARDS_ROUTE = 'dashboards';
export const EDIT_ROUTE = 'edit';
export const CREATE_ROUTE = 'create';
